module.exports = __webpack_public_path__ + "img/t6-salmon.df7748ad.png";